import { adminActionTypes } from "src/action_types/section_action_types";
import union from "lodash.union";
import without from "lodash.without";

export function checkedFacilityIdsReducer(state = [], action) {
  switch (action.type) {
    case adminActionTypes.selectFacilities:
      return union(state, action.payload);

    case adminActionTypes.deselectFacilities:
      return without(state, ...action.payload);
    case adminActionTypes.selectedPartner:
      return [];
    default:
      return state;
  }
}
